import React from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  emoji: '👩‍👦',
  title: 'Mamás',
  color: 'bg-pastel-pink'
}, {
  emoji: '👨‍👧',
  title: 'Papás',
  color: 'bg-pastel-blue'
}, {
  emoji: '👵',
  title: 'Abuelas',
  color: 'bg-pastel-purple'
}, {
  emoji: '👩‍🏫',
  title: 'Maestras',
  color: 'bg-pastel-mint'
}];
export function TargetAudience() {
  return <section className="py-20 px-4 bg-white" data-id="element-95">
      <div className="max-w-5xl mx-auto text-center" data-id="element-96">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-12" data-id="element-97">
          ¿Para quién es esta guía? 🎯
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-98">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`${item.color}/30 p-8 rounded-[2.5rem] border-4 border-white shadow-lg hover:-translate-y-2 transition-transform`} data-id="element-99">
              <div className="text-6xl mb-4" data-id="element-100">{item.emoji}</div>
              <h3 className="text-2xl font-bold text-brand-dark" data-id="element-101">
                {item.title}
              </h3>
            </motion.div>)}
        </div>

        <p className="mt-12 text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-102">
          Diseñada para cualquier persona que quiera ser parte activa y positiva
          en el desarrollo de los más pequeños de la casa.
        </p>
      </div>
    </section>;
}